import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export const PerformanceDetailCardWrapper = styled.div`
  margin-bottom: 0.5rem;
  ${breakpoint('tabletPortrait')`
    margin: 0;
  `};
`

export const PerformanceDetailCardGrid = styled.div`
  display: block;
  ${breakpoint('tabletPortrait')`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 0.5rem;
  `};
`
